<!-- 
    描述：外部对接字典 --- 左侧平台table
    时间：2021/03/02
    Created by zl
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="platform">
				<el-table :data="platformData"
						  :loading="loading"
						  highlight-current-row
						  highlight-hover-row
						  border
						  height="100%"
						  @row-click="rowClick"
						  :row-class-name="showFirst ? tableRowClassName : ''">
					<el-table-column prop="sname"
									 label="外部平台名称"
									 min-width="200px"
									 header-align="center"
									 show-overflow-tooltip></el-table-column>
					<el-table-column label="操作"
									 width="170px"
									 align="center">
						<template slot-scope="scope">
							<el-button type="success"
									   round
									   plain
									   class="table-btn"
									   v-if="roleBtns.includes('edit_platform')"
									   @click="doClick('edit', scope.row)">
								<svg-icon icon-class="form-edit"></svg-icon> 编辑
							</el-button>
							<el-button type="danger"
									   round
									   plain
									   class="table-btn"
									   icon="el-icon-delete"
									   v-if="roleBtns.includes('delete_platform')"
									   @click="doDelete(scope.row)">删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 新增、编辑平台弹窗 -->
		<el-dialog :title="dialogObj.title"
				   center
				   :visible.sync="dialogObj.show"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @close="doCancel">
			<el-form :model="platform"
					 label-width="120px"
					 :rules="platformRule"
					 ref="platformRef">
				<el-form-item label="外部平台名称"
							  prop="sname">
					<el-input v-model="platform.sname"
							  placeholder="请输入对接平台的名称"></el-input>
				</el-form-item>
				<el-form-item label="适用范围"
							  prop="applyBus"
							  :rules="applyRule">
					<el-select v-model="platform.applyBus"
							   placeholder="请选择适用范围">
						<el-option v-for="item in scopeOfApplyList"
								   :key="item.value"
								   :value="item.value"
								   :label="item.sname"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="key值">
					<el-input v-model="platform.identityNo"
							  placeholder="由对接方提供系统之间的识别码"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button class="btn btn-blue"
						   type="primary"
						   @click="doSubmit">提 交</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import {
	saveOrUpdateOutPlatform,
	deleteOutPlatform,
	getOutPlatformList,
	getApplyBusList,
} from 'api/modules/dict'
import { mapState } from 'vuex'
export default {
	name: 'LeftPlatformTable',
	data() {
		return {
			platformData: [], //平台列表
			loading: false,

			// 弹窗
			dialogObj: {
				show: false,
				title: '新增平台',
				width: '700px',
			},

			// 新增、编辑平台表单
			platform: {
				sname: '', //外部平台名称
				identityNo: '', //key值
				id: '',
				applyBus: '', //适用范围
			},

			// 新增、编辑平台表单验证规则
			platformRule: {
				sname: [
					{
						required: true,
						message: '外部平台名称不能为空',
						trigger: 'blur',
					},
				],
			},

			// 适用范围验证规则
			applyRule: [
				{
					required: true,
					message: '适用范围不能为空',
					trigger: 'change',
				},
			],

			showFirst: true, //是否是第一个row被选中
			selectIndex: 0, //当前点中的 row 的id
			scopeOfApplyList: [], //适用范围列表
		}
	},
	created() {
		this.getPlatformList()
		this.getApplyList()
	},
	methods: {
		// 获取外部平台列表
		getPlatformList(type) {
			this.loading = true
			getOutPlatformList()
				.then((res) => {
					if (res.operationCode == 1) {
						this.platformData = res.data
						type == 'edit'
							? ''
							: this.$emit('rowClick', this.platformData[0])
						this.loading = false
					}
				})
				.catch(() => {
					this.loading = false
				})
		},

		// 获取适用范围列表
		getApplyList() {
			getApplyBusList().then((res) => {
				if (res.operationCode == 1) {
					this.scopeOfApplyList = res.data
				}
			})
		},

		// 弹窗取消按钮
		doCancel() {
			this.dialogObj.show = false
			this.platform.id = ''
			this.platform.sname = ''
			this.platform.identityNo = ''
			this.platform.applyBus = ''
		},

		// 弹窗确认按钮
		doSubmit() {
			this.$refs.platformRef.validate((valid) => {
				if (valid) {
					let params = Object.assign({}, this.platform)
					saveOrUpdateOutPlatform(params).then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('新增完成！')
							this.getPlatformList('edit')
							this.dialogObj.show = false
						}
					})
				}
			})
		},

		// 新增、编辑外部平台
		doClick(type, data) {
			this.dialogObj.show = true
			if (type == 'add') {
				this.dialogObj.title = '新增'
			} else if (type == 'edit') {
				this.dialogObj.title = '编辑'
				this.platform.sname = data.sname
				this.platform.identityNo = data.identityNo
				this.platform.id = data.id
				this.platform.applyBus = data.applyBus
			}
		},

		// 删除外部平台
		doDelete(data) {
			this.$confirm('此操作将删除该外部平台', '提示', {
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					deleteOutPlatform({
						id: data.id,
					}).then((res) => {
						if (res.operationCode == 1) {
							this.$message.success('删除成功！')
							this.getPlatformList()
						}
					})
				})
				.catch(() => {
					this.$message.info('操作取消！')
				})
		},

		// row 点击
		rowClick(data) {
			this.$emit('rowClick', data)
			this.showFirst = false
			this.selectIndex = this.platformData.findIndex(
				(x) => x.id == data.id
			)
		},

		// 自定义行的样式
		tableRowClassName({ row, rowIndex }) {
			if (this.selectIndex === rowIndex) {
				return 'high-row'
			}
			return ''
		},
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns, //按钮权限
		}),
	},
}
</script>
<style lang='less' scoped>
/deep/.high-row {
	background-color: #e6f7ff !important;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		width: 5px;
		height: 41px;
		background-color: #2671cc;
	}
	border-left: 5px solid #2671cc;
}

/deep/ .el-table--border {
	td,
	th.is-leaf {
		border-bottom: 1px solid #dcdcdc !important;
		border-right: 1px solid #dcdcdc !important;
	}
}
</style>
